import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card operations" }
const _hoisted_2 = {
  key: 1,
  class: "flex-1 min-w-0 text-sm overflow-hidden",
  style: {"text-overflow":"ellipsis"}
}
const _hoisted_3 = {
  key: 1,
  class: "p-fluid"
}
const _hoisted_4 = { class: "p-2 flex flex-column gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_PrimeVueInputNumber = _resolveComponent("PrimeVueInputNumber")!
  const _component_PrimeVueMultiSelect = _resolveComponent("PrimeVueMultiSelect")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h6", null, "Creatives")
      ])
    ], -1)),
    (_ctx.creatives.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.creatives, (creative, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "insights flex align-items-center gap-3",
            key: creative.creative_id
          }, [
            _withDirectives(_createVNode(_component_PrimeVueButton, {
              class: "flex-shrink-0 p-button-rounded p-button-text p-button-secondary",
              icon: "pi pi-eye",
              onClick: ($event: any) => (_ctx.$emit('previewCreative', creative))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('preview'),
                void 0,
                { left: true }
              ]
            ]),
            (_ctx.optionsLoading)
              ? (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
                  key: 0,
                  class: "flex-1",
                  height: "1rem",
                  "border-radius": "4px"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getLabel(creative.creative_id)), 1)),
            _withDirectives(_createVNode(_component_PrimeVueInputNumber, {
              class: "flex-shrink-0",
              modelValue: creative.weight,
              "onUpdate:modelValue": ($event: any) => ((creative.weight) = $event),
              min: 0,
              max: 100,
              step: 5,
              "use-grouping": false,
              "show-buttons": "",
              "button-layout": "horizontal",
              "increment-button-icon": "pi pi-plus",
              "decrement-button-icon": "pi pi-minus",
              "input-style": "max-width: 40px"
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
              [
                _directive_tooltip,
                _ctx.$t('weight'),
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_PrimeVueButton, {
              class: "flex-shrink-0 p-button-rounded p-button-text p-button-danger",
              icon: "pi pi-trash",
              onClick: ($event: any) => (_ctx.deleteCreative(index))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('delete'),
                void 0,
                { right: true }
              ]
            ])
          ]))
        }), 128))
      : _createCommentVNode("", true),
    (_ctx.availableOptions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_PrimeVueMultiSelect, {
            modelValue: _ctx.selectedIds,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedIds) = $event)),
            loading: _ctx.optionsLoading,
            options: _ctx.availableOptions,
            "option-value": _ctx.optionValue,
            "option-label": _ctx.optionLabel,
            "data-key": _ctx.optionValue,
            filter: "",
            placeholder: "Select creatives ..."
          }, {
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("small", { class: "text-color-secondary" }, "Select creatives and click \"Add to campaign\" to use them in this campaign", -1)),
                _createVNode(_component_PrimeVueButton, {
                  class: "w-full p-button-sm",
                  label: "Add to campaign",
                  icon: "pi pi-plus",
                  disabled: !_ctx.selectedIds.length,
                  onClick: _ctx.addSelected
                }, null, 8, ["disabled", "onClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "loading", "options", "option-value", "option-label", "data-key"])
        ]))
      : _createCommentVNode("", true)
  ]))
}